import { Injectable } from "@angular/core";
import { SerialportService } from "../serialport/serialport.service";
import { catchError, first, from, map, Observable, of, switchMap, timeout } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SerialPrinterService {

    private _isPrinting = false;

  constructor(private _serial: SerialportService) {
    this._serial.connect().then(() => {});
  }

  private _printerWrite(data: string): Promise<void> {
    if (this._serial.isOpen() == false) {
      console.log("Printer not connected");
      return Promise.resolve();
    }
    // const latin1Buffer = buffer.transcode(Buffer.from(data), "utf8", "latin1");

    // var utf8Array = new TextEncoder().encode(data);
    // const latin1Buffer = new TextDecoder('windows-1252').decode(utf8Array)

    // const buf = iconv.decode(iconv.encode(data, 'utf-8'), 'iso-8859-1');
    // const latin1Buffer = iconv.encode(data, 'win1252');

    // const latin1Buffer = Buffer.from(data).toString('latin1');

    // const latin1Buffer = iconv.decode(Buffer.from(data), 'ISO-8859-1');
    // console.log(latin1Buffer);
    const win1252 = this._stringToBytes(data);
    return this._serial.sendData(win1252);
  }

  /**
   * Converts a string to an array of bytes. Any characters not in ISO-8859-1
   * will be replaced with a question mark.
   * @param str the string to convert
   * @returns an array of bytes
   */
  private _stringToBytes(str: string) {
    const len = str.length;
    const res = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      const code = str.charCodeAt(i);
      let byte = code;
      if (code > 255) {
        if(code === 8364) byte = 80; // €
        else byte = 63; // ?
      }
      res[i] = byte;
    }
    return res;
  }

  private _waitForPrintFinished(timeoutMs: number): Promise<string | undefined> {
    return new Promise<string>( (resolve, reject) => {
        if(this._serial.isOpen() == false) {
            resolve('');
            return;
        }

        this._serial.readData().pipe(
            timeout({ first: timeoutMs }),
            first()
        ).subscribe({
            next: (data: string) => {
                console.log(data);
                if(data.includes('Y')) {
                    console.log('OK');
                    resolve('OK');
                }
            },
            error: () => {
                console.log('timeout');
                resolve('not OK');
            },
            complete: () => {
                console.log('complete');
                resolve('not OK');
            }
        });
    });
}

//   public async printLabel(fileName: string): Promise<void> {
//     if (this._isPrinting) {
//       return;
//     }
//     this._isPrinting = true;
//     const label = await readFile(fileName, "utf8");
//     await this.serialWrite(label);
//     await this.waitForPrintFinished(5000);
//     this._isPrinting = false;
//   }

  public async printEZPL(data: string): Promise<void> {
    if (this._isPrinting || data === "") {
      console.log("Already printing or data is empty");
      return Promise.resolve();
    }
    console.log('start printing');
    this._isPrinting = true;
    await this._printerWrite(data);
    await this._waitForPrintFinished(5000);
    this._isPrinting = false;
  }

  public getState(): Observable<string> {
      return from(this._printerWrite('~S,STATUS\r')).pipe(
        switchMap(() => this._serial.readData().pipe(
            timeout({ first: 1000 }),
            first(),
            map((data) => {
              if(data.startsWith('00')) return 'Ready';
              else if(data.startsWith('01')) return 'Media Empty or Media Jam';
              else if(data.startsWith('02')) return 'Media Empty or Media Jam';
              else if(data.startsWith('03')) return 'Ribbon Empty';
              else if(data.startsWith('04')) return 'Printhead Up ( Open )';
              else if(data.startsWith('05')) return 'Rewinder Full';
              else if(data.startsWith('06')) return 'File System Full';
              else if(data.startsWith('07')) return 'Filename Not Found';
              else if(data.startsWith('08')) return 'Duplicate Name';
              else if(data.startsWith('09')) return 'Syntax error';
              else if(data.startsWith('10')) return 'Cutter JAM';
              else if(data.startsWith('11')) return 'Extended Menory Not Found';
              else if(data.startsWith('20')) return 'Pause';
              else if(data.startsWith('21')) return 'In Setting Mode';
              else if(data.startsWith('22')) return 'In Keyboard Mode';
              else if(data.startsWith('50')) return 'Printer is Printing';
              else if(data.startsWith('60')) return 'Data in Process';
              else return 'Unknown';
            })
        )),
        catchError(() => of('ERROR'))
      );
  }
}
